export default "__VITE_ASSET__CKNsxZL7__"